import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, openModal } from "risa-oasis-ui_v2";
import { LoaderMessage } from "../../../../components/loaderMessage/loaderMessage";
import NewFacilityModal from "../../../../components/modals/newFacilityModal/newFacilityModal";
import { HealthCareFacilityModel } from "../../../../data-model/healthFacility";
import { fetchHealthFacilityFromFirebase } from "../../../../redux/slice/healthFacilitySlice";
import { AppDispatch, RootState } from "../../../../redux/store/store";
import HealthCareDetails from "./components/healthCareDetails/healthCareDetails";
import HealthFacilityCard from "./components/healthFacilityCard/healthFacilityCard";

const HealthFacilityConfiguration = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { data: healthFacilityData, loading } = useSelector(
    (state: RootState) => state.healthFacility,
  );

  const [healthFacilityList, setHealthFacilityList] = useState<
    HealthCareFacilityModel[]
  >([]);
  const [showNewFacilityModal, setShowNewFacilityModal] =
    useState<boolean>(false);
  const [selectedHealthCareFacilityIndex, setSelectedHealthCareFacilityIndex] =
    useState<number>(0);

  useEffect(() => {
    dispatch(fetchHealthFacilityFromFirebase());
  }, [dispatch]);

  useEffect(() => {
    if (healthFacilityData && !loading) {
      setHealthFacilityList(healthFacilityData);
    } else {
      setHealthFacilityList([]);
    }
  }, [healthFacilityData, loading]);

  useEffect(() => {
    if (showNewFacilityModal) {
      openModal("new-facility-modal");
    }
  }, [showNewFacilityModal]);

  // Pharmacy tab only shows facilities tagged for the pharmacy dashboard.
  const visibleFacilities = healthFacilityList.filter(
    (f) => f.dashboard_type === "pharmacy",
  );

  useEffect(() => {
    const firstPharmacyIndex = healthFacilityList.findIndex(
      (f) => f.dashboard_type === "pharmacy",
    );
    setSelectedHealthCareFacilityIndex(
      firstPharmacyIndex === -1 ? 0 : firstPharmacyIndex,
    );
  }, [healthFacilityList]);

  return (
    <div className="health-facility-config layout flex h-full flex-col gap-4 overflow-hidden">
      {loading ? (
        <>
          <div className="h-full w-full">
            <LoaderMessage message={"Loading health care facilities..."} />
          </div>
        </>
      ) : (
        <>
          <div className="health-facility-config header flex items-center justify-between border-b border-gray-200 pb-2">
            <div className="health-facility-config header text text-h11 font-semibold">
              Health Care Facility Configuration
            </div>
            <div className="health-facility-config header action">
              <Button
                disabled={false}
                children={"Add New Facility"}
                onClick={() => {
                  setShowNewFacilityModal(true);
                }}
                buttonType={"primary"}
                size={"medium"}
              />
            </div>
          </div>
          <div className="health-facility-config body flex flex-1 gap-4 overflow-hidden">
            <div className="health-facility-config body left b flex flex-1 flex-col gap-4 overflow-auto">
              {visibleFacilities.map((healthFacility) => (
                <div
                  key={healthFacility.DocId ?? ""}
                  onClick={() => {
                    setSelectedHealthCareFacilityIndex(
                      healthFacilityList.indexOf(healthFacility),
                    );
                  }}
                >
                  <HealthFacilityCard
                    key={healthFacility.DocId ?? ""}
                    healthCareData={healthFacility}
                    isActive={
                      selectedHealthCareFacilityIndex ===
                      healthFacilityList.indexOf(healthFacility)
                    }
                  />
                </div>
              ))}
            </div>
            <div className="health-facility-config body right flex-1 overflow-hidden">
              <HealthCareDetails
                singleHealthCareData={
                  healthFacilityList[selectedHealthCareFacilityIndex]
                }
              />
            </div>
          </div>
          {showNewFacilityModal && (
            <NewFacilityModal
              data={null}
              onModalClose={() => setShowNewFacilityModal(false)}
              type={"add"}
            />
          )}
        </>
      )}
    </div>
  );
};

export default HealthFacilityConfiguration;
